var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMx(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M35.6 0h17.7v40H35.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.8 0h17.8v40H17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006847",
    d: "M0 0h17.8v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcca3e",
    d: "M29.7 24.1v.4l.1-.1zm-.1 0a.1.1 0 1 0 0-.2.1.1 0 0 0 0 .2m.4.6-.2-.3-.1.1zm0 .2.1-.2h.2v.2zm2.2-4.1.3.3v-.2zm0 0a.1.1 0 1 0 0-.2.1.1 0 0 0 0 .2m.8.2h-.5zm0 0a.1.1 0 1 0 0-.2.1.1 0 0 0 0 .2m-1.5 2-.3-.3zm-.3-.3a.1.1 0 1 0 0-.2.1.1 0 0 0 0 .2m.3.3.3.1zm.5.3a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3m-8.3.7v.1l-.1-.1v-.1zm0 .2.1.4h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcca3e",
    d: "m23.8 24-.1.2h-.2l.2-.1zm-.8.7.2-.1-.1-.1h-.2zm.3-.1h.4v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcca3e",
    d: "M23.3 24.6v.2q-.2 0-.1-.1v-.2zm-1.3-2 .1-.2H22zm0 .1v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcca3e",
    d: "m22.2 22.6-.2.1-.2-.1q.1-.2.2 0 .1-.1.2 0m-.8.5V23h-.2zm.2-.1h.3l.1.1h-.4m-.1-.2.1.2-.2.1zm-.3-2.4H21zm-.2.6.2-.4-.3.3zm.1-.4v-.2h.1l.1.1v.1zm-.7 0 .1.1h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcca3e",
    d: "m20.5 20.9.3.1v.2zm0 0h-.2v-.1l.1-.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aa8c30",
    d: "M29.7 24.1h-.2v-.2.2zm.4.6-.4-.2zm.2 0v.2H30v-.1.1h.1zm2-3.9H32v-.1.1zm.8 0-.1.2-.1-.1v.1h.2zm-.3.2h-.1.2m-1.4 1.8-.1-.2m0-.2h-.2v-.1H31v.1h.2m.4.5h-.2zm.4.2v.1l-.2-.1v.1h.2m-8.2 1-.1.1h-.2.3zm-.4.4h.1zm0 0v.1l-.1.1h-.1v-.1.1h.1zm-.4 0v.1h.2-.2m-.8-2h-.3v.1h.2zm-.6.4.3.1h-.3m0 0q0 .2-.2.2h.1zm-.2 0h-.2v.1h.2m-.1-2.4v.1h-.4.3m-.6-.1v.1l.2.2-.3-.2m-.1.1h-.2zm-.2-.1h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ca168",
    d: "M33.3 20q-.1.5-.5.6l-.2.3v.2h-.1v.7l.2-.2h.2l-.2.3q0 .4-.5.7l-.4.2h-.1l-.1.2-.1.1-.1.1v.2l-.1.2h.2q.1.1-.4.6c-.3.2-1 .2-1 .2h-.2l-.2.1v.2l-.3.2-.2.1h.2l.3.2h-.3c-.1 0-.7.4-1 .4-.2 0-.6-.4-.6-.4l-.2-.2h-.7v-.1h1l.5-.4.5-.1h.3v.1l-.1.1h.4l.4-.3.2-.4.4-.4.2-.3.1-.2v.4l.4-.2h.2l.1-.2.1-.2V22l.2-.4.3-.3v.2l.3-.2v-.9l-.1-.4v-.5l-.1-.1.2.2.2.4.2-.9.2.3v.3l.1-.3v.1q.2.1.2.5m-5.6 5.4-.3-.2-.5-.2v.1l.5.2.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#717732",
    d: "m29.6 24.6.4-.3h.3l.5-.2.5-.5h.2l-.3.2-.5.4-.6.2-.3.1zm1-1-.4.6.4-.4.5-.3.2-.3s0-.2-.7.4m-.7.7.2-.2V24l.6-.5V23v.2l-.6.6v.3zm-.2.9-.4-.1-1 .2q-.4 0-.6-.2c-.2-.2-.8-.2-.8-.2l.6.1q.3.3.8.4l1-.3zm-2-.2.5-.2.7-.4h.4-.9l-.4.4zm0 .4h-.2l-.2-.2h-.4.4l.2.2.1.1zm.1-.3h.4q.6-.1 1-.4h.4l-.3-.1q-.8.1-1.2.4zm4.7-3.3-.5.7-.2.3-.3.3q-.2 0 0 0l.2-.3q.3 0 .5-.3l.4-.8.3-.2zm-.7.9v-.2l.3-.3.2-.6.2-.4-.3.2-.4.7zm-.2.2v-.3l.1-.7c0-.2.5-.6.5-.6l-.4.2q-.3.3-.3.5l.1.5zm.9-1.7.1-.4.2-.4q.3 0 .3-.3v-.7.2l-.1.5-.3.5v-.4l.1-.5V19l-.1.3-.2.6.1.5v.5zm-.3-1.8v.8l.3.3v.3-.5l-.1-.1v-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ca168",
    d: "m25.6 25.4.2-.2.6-.2v.1h-.2l-.2.2-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ca168",
    d: "M26.1 24.8h-.5v.1l-.2-.1v.1l-.5-.3v.3l-.5-.4v.3h-.1l-.3-.2v.3h-.4l-.1.1h.1l.1.1h.4l-.2.2h.4l.3-.2-.2.4h.3l.4-.3-.1.3h.2l.3-.3h.1l.2-.1.3-.2h.2l.1.1v-.1zm-2.2 0v-.1l-.2-.2-.2-.1-.2-.1V24H23l-.1-.5v-.1h-.1l-.1.3-.2-.2v-.4l-.2.2-.2-.4v.2q-.3 0-.5-.4v-.6h-.1v-.4l-.1-.1-.2.3-.1-.2v-.3l-.2.2v-.2l-.1-.4-.1-.4v-.2l.3-.4h-.3l.3-.4q-.1-.2-.2 0l.1-.3V19l-.2.2h-.2v.2l-.1.2-.2-.1v.5h-.1v.2l.2.1.1.2h.1l.1.2v.8h-.2l.1.3.4.1s-.4-.2-.4 0l.3.3h.4l-.3.2.2.1h.2l.4.4.4.3H22s.4.2.3.3q-.3-.1-.4 0l.2.3h.5l-.5.2.4.3.3-.1v.1h.4l.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#717732",
    d: "M25.7 25.3h.1l.3-.1.3-.1-.3.1-.3.2zm.7-.3-.2-.1-.4.1v.1h.1l.3-.2zm-4.2-1.7L22 23l-.4-.3.2.2zm3 2v-.1l.3-.2-.1-.1v-.1.1h.2l-.3-.2v.2l-.4-.4h-.2l.1.3-.4-.3h-.2l.1.3-.3-.2h-.2v.2h-.2l-.1.2.2-.1h.5-.1l-.1-.2.1.1.2.1h.1v.2h-.2.2l.1-.1h.1v-.2l-.2-.2.2.2.1.2h.1v.1l-.1.2.1-.1.1-.2h.2l-.2-.2.2.2v.1h.2v.2zm-1.8-1h.1l-.2-.1v-.4l-.2.2v-.5q0-.3-.3-.2l-.1.3V23l-.2-.2v.3l-.1-.2h-.1v.1q-.1 0 0 .1v.3H22h.3l.1.3V23v.5l.1.1H22h.6l.1.3.1-.3v-.2.5h-.2l-.3.1h.6l.1.1-.2.1h.3V24v.3zm-2.6-3v-.2q0-.3-.2-.5l.1-.1h-.2.1v-.2h-.2l-.2-.2.2.1h.5-.3V20h-.2v-.3.1l.2.1h.1l.2-.2h-.2l-.1.2v-.6.2l.4-.3h-.3l-.2.2v.2l-.2-.1-.1.2.2.4c-.1 0-.3-.3-.4-.1q.1.3.4.4v.1l.2.1.2.5zm1 1.5-.1-.3.1-.5-.2.1v-.5l-.1-.1-.2.3v-.4H21v.1l-.3-.1.2.3h.1v-.2.3h-.3.4l.1.3V22l.2-.2v.3l-.1.2h-.5.5l.1.3.1-.2v-.1.2l-.2.1h-.2.4v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.2 25.9h-.1l-.1-.1v-.2l.5-.4v-.5h.3v.6h.1l.5.4v.1H27l-.3-.2-.2-.1-.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016848",
    d: "M26.6 24.7v.6l-.5.3-.1.2h-.1l-.2.1.3-.4.4-.3v-.4zM27 26h.1l.1-.1h-.1l-.3-.2-.2-.2-.1.1.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cd202a",
    d: "M26.8 24.7h.1v.8l-.4.3-.2.2-.1-.1q0-.3.3-.3l.3-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cd202a",
    d: "M27.7 25.8h-.3l-.1-.1-.3-.2-.2-.1v-.2l.3.2.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30c2dc",
    stroke: "#0872a7",
    strokeWidth: 0.1,
    d: "M28.8 23.9s-.4-.1-.3-.3l.7-.2v-.2h-.3l-.7.2-2.9-.2c-.3 0-.5-.5-.5-.5h-.1v.3l-1.2-.5v.2l.5.4q-.1.2-.2.1l.1.2s1 0 1 .3q-.1.3-.2.2v.1s.6 0 .8.2l.4.3h1.6l.7-.4.5-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#0872a7",
    strokeWidth: 0.1,
    d: "M23.7 23.6a.2.2 0 1 0 0-.4.2.2 0 0 0 0 .4Zm1-.8a.2.2 0 1 0 0-.4.2.2 0 0 0 0 .4Zm4.2 1.2a.2.2 0 1 0 0-.3.2.2 0 0 0 0 .4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "M23 22.3q-.2.3.3.4h.2v-.3q-.3-.2-.6 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m23.4 22.5-.2-.1h-.1l.2.1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "m24.8 24-.2.3-.4-.1q0-.2.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.6 24v.1h.1zl-.3.3h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "M29.1 23.4q.2.2.3 0 .3 0 .2-.3h-.3l-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m29.1 23.3.2-.1h.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9aa51",
    stroke: "#953220",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M26.8 23h-.6l.3.8.3.5h.4v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9aa51",
    stroke: "#953220",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M25.9 23h.3l.3.4.2.5.3.5h-.4l-.1-.1-.5-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9aa51",
    stroke: "#953220",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M25.7 23h.2l.3.4.2.6.2.4h-.5l-.3-.1-.1-.2h-.2V23zm2 .1h-.4l-.6-.1v.3l.3.6.2.4h.6v-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9aa51",
    d: "M25.6 23.1v.1l.2-.1q0-.2-.2-.2t-.2.3v.4l.1.3-.1.2q0 .2.2.2l.2-.1-.1-.2h-.1m2.1-.8h-.1l.1-.2.3.2-.1.3v.6l-.1.2-.3-.1.2-.2v.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#953220",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M25.6 23.1v.1l.2-.1q0-.2-.2-.2t-.2.3v.4l.1.3-.1.2q0 .2.2.2l.2-.1-.1-.2h-.1m2.1-.8q0 0 0 0h-.1l.1-.2.3.2-.1.3v.6l-.1.2-.3-.1.2-.2v.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#953220",
    d: "M25.8 24v.2l.9.1h.7l.2-.2v.3h-1.7l-.1-.2zm1.7-1v.3l-.1.2h-.5l-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M28.9 23h-.1v-.2zm.8-.2h.1l.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M30 22.9h-.1l-.1-.1zm.4-.4h-.2zm-.6-.9h-.2v.2zm-.5.2v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8cbebf",
    stroke: "#04534e",
    strokeWidth: 0.1,
    d: "m28.6 22.4-.3.2s.6.3 1 .3q.7-.1 1-.4l-.1-.5-.5-.3-.5.4q0 .2-.4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c8489",
    d: "m28.5 22.5.8-.1.4-.5h.3l.2.1v.5l-.1.1-.4.2h-1.1l-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534e",
    d: "M29.4 22.1h.2l-.1.2zm.2.2h.2zm0 .3v.1zm-.4 0 .2-.2v.2zm-.4 0a.1.1 0 1 1 .2 0 .1.1 0 0 1-.2 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8cbebf",
    d: "M29.6 22.3h.1m0 .3h.1zm-.4 0 .2-.2v.2zm.2-.5h.1v.1zm-.6.4h.2l-.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M29 22.5h-.1v.1zm.4-.1h-.1v.2zm0 0-.1.2zm.1-.4v.1zm.3.2q-.2 0 0 0m0 .3-.1.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534e",
    d: "M30.2 22.3v.2q-.4.3-1 .4l-.8-.3.3.2.4.1h.4l.3-.1.3-.2h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M23 20.2v.2zm.6.6-.1.1zm-1.5 0 .1.1h.1zm.3.6h.2zm.4.3h.2v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8cbebf",
    stroke: "#04534e",
    strokeWidth: 0.1,
    d: "M23.6 21.4q.1-.2-.4-.8-.6-.5-.8-.2-.4.4.2 1c.4.3 1 .2 1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c8489",
    d: "m22.3 20.9.1-.4q.4-.2.8.3l.2.8H23l-.3-.1-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534e",
    d: "M23.5 21.5h-.2c-.2 0-.9-.1-1-.7v.3l.2.2.2.1.2.2h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534e",
    d: "M23.1 21.3h.1v.1m0-.3h.2zm-.2.4h.1zm0-.4v.1zm-.4 0h.2v.1zm0-.3h.2v.1zm.4 0h.2l-.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8cbebf",
    d: "M22.6 20.7h.1zm.3 0h.1zm.3.3h.1v-.1zm-.4.4.1-.1zm.3-.1h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M23.2 20.8v.2zm-.2-.3v.2zm-.4 0v.2zm-.1.1h.1v.1m.3.3.1.1zm-.3 0q.2 0 0 .1m.7.2v.2zm-.2-.1q.2.1 0 .1m-.3 0v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534e",
    d: "M22.7 20.3q-.2 0-.3.3l-.1.3v-.3l.1-.2h.2m.8 1v-.2l-.3-.5.2.1v.2l.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "m23.8 21 .1.1zm-.4 1h.2zm.7.3.1-.1zm-.1 0v-.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8cbebf",
    stroke: "#04534e",
    strokeWidth: 0.1,
    d: "M25.1 21.8s-.4-.6-1-.7a.6.6 0 0 0-.7.6q0 .3.9.5 1-.2.8-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c8489",
    d: "m24.6 21.4.3.2v.2s-.4-.4-.7-.4q-.5-.1-.6.1v.5l.9.2h.3l.2-.2v-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534e",
    d: "M24.1 21.4v.1h-.2zm-.4.2h.1m.4.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8cbebf",
    d: "M23.8 21.9v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534e",
    d: "M24.4 22h.1v.1zm.2-.1h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8cbebf",
    d: "M23.9 21.6h-.1m.4.2h-.1v-.1m.5 0-.1.1zm-.3.2h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M24.5 21.8h.2zm-.2.3h.1zm-.2-.5.1.1v.1zm-.1.2h.2zm-.2 0q.2 0 0 .1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M23.8 22v-.1h.1zm-.1-.5.1.1zm.2-.2h.1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534e",
    d: "m25 22-.6.1q-.9 0-1-.4v.1l.1.1.4.2h.3l.3.1h.3zm0-.2-.1-.2-.5-.4.3.2.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M25 21.4h.2v.1zm.4-.2h.2v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M25.5 21.2h.1v.2zm.6 0v.3-.2m.1.2h.1v.1zm-1 1.2h.2v-.1zm.6.1h.1v-.1zm.4 0h.2v-.1zm.2 0v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8cbebf",
    stroke: "#04534e",
    strokeWidth: 0.1,
    d: "M25 22q0-.5.6-.7l.6.2.4.2h.7l-.3.5h-.1l-.4.4h-1q-.4-.2-.5-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534e",
    d: "M25 22v-.2l.3-.3.3-.1h.3l.3.1.2.2h.9l-.3.4-.1.1-.4.4h-1l-.3-.2zl.1.4.4.2h1q.3 0 .4-.3l.1-.1.4-.6-.5.1h-.4l-.2-.2-.7-.2-.2.1-.3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c8489",
    d: "m27 22-.1.1s-1-.6-1.3-.5q-.5 0-.5.4v.4l.7.2h.6l.3-.2h.1v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534e",
    d: "M25.5 22h-.1v-.1zm.1-.3.1-.1h.1v.1zm.6.1h.2zm.1.3h.2v.1zm-.3.3.1-.1h.1v.1zm-.5-.1h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8cbebf",
    d: "M25.5 22h-.1v-.1zm.3-.4v.1h-.2zm.5.2h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534e",
    d: "M26 22v.1h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8cbebf",
    d: "M25.7 22.3h-.2l.1-.1m.3-.3h.1zm.5.1-.1.1h-.1V22zm-.3.3H26l.1-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M26.2 22h.2v.2zm-.1-.4.1.1v.1zm-.3.3v.1zm-.1.1h.2zm-.1-.5v.2zm-.3.3v.1zm-.1.2.2-.1zm.7.4h.2zm-.5 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534e",
    d: "m26.9 22.2-.3.3H26a1 1 0 0 1-1-.4v.1l.2.2.2.1.3.1h.9l.1-.1v-.1zm-.3-.5h-.2l-.7-.3q-.5.1-.6.3l.2-.2.2-.1h.5l.2.1h.2zm.5.1h-.3v.1l-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c8489",
    stroke: "#04534e",
    strokeWidth: 0.1,
    d: "M26.7 23.4h.6l.1-.4h.1l.3-.2h.2l.2-.1h.2l.1-.1.1-.2v-.3l-.2-.2-.2-.1h-.5l-.5.2-.3.3q-.3.3-.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8cbebf",
    d: "M26.9 23.3v-.4l.3-.3h.2v-.3l.3-.1h.2l.2-.1h.1v.3l.2-.1v-.1h.2q0-.2-.2-.3l-.2-.1h-.4l-.3.2-.3.2v.2l-.2-.2-.1.4-.1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8cbebf",
    d: "M27.2 22.9H27v.2h.1zm.5-.4h-.1v.1h.1zm.4 0q-.2 0-.1.1m-1.2.1a.1.1 0 0 0 .2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534e",
    d: "M27.3 23H27zm1-.7h-.1zm-1 .2v.1m.3 0v.1h.2zm.3-.4v.1h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534e",
    d: "M26.8 23.4h.5l.2-.5.6-.2q.4 0 .5-.4l-.2-.3q-.2-.2-.4-.1h-.3l-.1.3h-.4v.2-.3l.3-.2.4-.3h.3l.3.2.2.2v.3q0 .4-.6.4l-.6.2-.1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M27 22.6v-.2zm.3 0v-.2l.1-.1v.1zm-.1.4v-.3.2m.2-.1-.1.1h-.1zm.5-.3h-.2zm-.1-.4.1-.1zm.6 0h-.1v.2zm-.2.4-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M24.4 21.6q.2 0 .3-.3 0-.4-.2-.4l-.3.3q0 .3.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcca3e",
    d: "m24.6 20.6-.1.3zm.1-.2-.1.1v.1h.2zm6.1.9-.3.3h.1zm.2-.1a.1.1 0 0 0-.2 0v.2h.2zm-9.1-1.8.2.4zm-.1-.2v.2h.2v-.1a.1.1 0 0 0-.2 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aa8c30",
    d: "m24.7 20.4-.1.1v.1-.1zm6.3.8h-.2v.2-.2zm-.2.2-.2.1zm-9-2.2v.2h.2-.2zm.2.2v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M22 20.3q.3.3.5.2t0-.4-.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e92736",
    d: "M21.9 20.1h.1v-.2l-.1-.1-.1.1zm.1-.3v.1h.2v-.2zm.4 0v-.2h-.2v.2zm1.9 1v.1h.1zv-.1zm.2 0v.1h.2v-.1l-.2-.1m.3.3v-.2h-.1v.2m5.5.5v.1h.2v-.1l-.1-.1zm.3 0v.2h.2zm0 .4h.2v-.2h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e204",
    d: "M22 20h-.1v-.1zm0-.2h.2zm.3-.1v.1zm2.2 1.1v.1h.2zm.2 0v.1h.1m5.9.9v.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m30 22.2.4-.1.1-.4h-.4q-.2.3-.1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8ac71",
    d: "M23.8 16.6h-.5c-.2 0-.2-.6-.2-.6l-.1-.3.5-.5h.2v.2l-.1.2-.1.2v.1h.3l.1-.2-.2.2-.2.1q-.1.1.1.2h.3zM22.6 18l.1.3-.1.7q-.1.3.4.7.2 0 .2.2s0 .7.5.7l.5-.3-.2-.3h-.2l-.2-.2-.2-.4-.4-.6.1-.7c0-.3-.5-.4-.5-.4l-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1a720",
    d: "M23.7 15.6c.2 0 0-.4 0-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8ac71",
    d: "M24 19.3q-.3-.1-.3-.8c0-.6.9-1 1-1.2s.2-.3-.5-.9l-.2.2.3.2h.1l-.1.3-.5.4-.2.2-.2.3-.1.5s0 .7.7.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78732e",
    d: "M23.6 19.6v.3h-.2l-.1.1-.1-.2h.2zm-.4 0H23v-.1h.1zm.2-.3.1.2h-.3zm0 1V20h.2zm.3-.3v-.1h-.1zm-.3.4h.2v-.1zm.3-.1.2-.2V20h-.1v.3m-.1.2h.4l.1-.2H24zm-.2-1.7v-.2h.1zm.1.3v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6c7a6",
    d: "M23 15.6v.2l.5-.2v-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8ac71",
    d: "m23.3 15.3-.1.2zh.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78732e",
    d: "M23.7 18.7v-.2h-.1v.2m-.4-.2V18v.2l.2.2zm.4 0v-.3l-.1.2m-.2-.4v-.2l.2-.1v.3zm.4.2.1-.2h-.2v.2m-.2-.6h.1l.1-.1v.3zm.6.4.1-.1-.3-.1v.2zm0-.4v-.3l-.1.2zm.3-.3v-.2l-.2.1zm0 .3.2-.1.1-.1h-.3zm-.7-1.1h.3-.1v-.1l-.2-.1m.5 1.3h.2v-.2h-.2zm.6-.5V17l-.2.2v.2zm-.4-.2h.3-.1l-.1.1m.3-.1v-.2h-.1l-.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.6 18.5h.2l.2.1-.2-.2zm0-.5h.4v-.1h-.2zm.5.4-.2-.1h-.2.2zm-.5-.4.1-.2h.1-.1zm0-.2.1-.1zv.2zm.6-1.6h.2v.2l-.2.2h.1v-.2l.2.2.1-.2.2.1-.2-.1.2-.2-.2.1v-.1l-.2.1v-.2zv.1zm.2.2.1-.2.1.2v.2zm-.7 1.7h.4zm1.8-1 .2-.2h-.3v-.3H24h.3v.3h.2zl-.1-.2zv.2H24v.3l-.2-.1v.3l-.3-.2v.5l-.2-.1.1.4h-.2v.2h.2l-.1.2h.3l-.1-.1v-.3l.1-.2V18h.2v-.3h.2v-.2h.3v-.2h.2zm-.9 1.4h-.2zm.1-.3-.1.2-.2-.4.2.1zm.2-.2h-.2v-.3h.1zm0-.2v-.3l.2.1v.2zm.4-.2h-.2v-.3h.2zm0-.3v-.2h.2v.2zm-.6 1.6h-.3zv.2zv.2h.2-.2v-.3m-1-.1h.3l-.2-.1h-.2zm1.2 1.6h-.3l.1-.1.3-.2-.3.1V20h-.2v-.3l-.1.3-.2-.1.1.1v.1l.2.1-.2.2h.4l-.1.2zl.1-.2zm-.6-.4h.3v.1zm.1.3.1-.1q.3-.1.2-.2v.3zm-.1-.8h.2zl.1-.2h-.2zH23v.1zv.2zM23 19v-.1h-.2l-.2.2.2-.1zm.3.2H23l-.1.2.2-.1zm-.4 0 .2-.2h-.2l-.2.2v.1zm.5-3.8h.1v.3l-.2.2v.2l.1-.1v-.3l.1-.2v-.2zl-.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78732e",
    d: "M23.8 16.2h-.2v.2zm-.3 0h-.1v.1zm0 .4-.2-.2v.2zm.6 3.7-.4.2-.3-.1-.1-.2V20l-.2-.3-.3-.3-.2-.5v-.3l.2-.3-.2-.2V18h-.2.1l.1.1.1.1v.3l-.2.4v.1l.3.5.3.2.1.4v.3l.2.1.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78732e",
    d: "M24 20h-.2l-.1-.1-.1-.2-.1-.3-.3-.3-.2-.3v-.3l.1-.4-.3-.4h-.2l.3.1.2.3v.4l-.2.3q0 .3.3.3l.3.3v.3l.2.2h.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8ac71",
    d: "m24.7 19.3.1.1v.3l-.2-.1v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "M22.2 17.9H22v-.3l.2-.2zm.2.1h-.2v-.4l.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "M22.6 18h-.2v-.2h-.1l.1-.2h.2l-.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#af7029",
    d: "m24.5 19.3-.2-.2-.2-.3h-.2l-.1-.3v-.3l.1-.1s-.4.1-.2.8q.2.5.3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#816c2a",
    d: "M24.3 16.8v.1q0 .4-.6.6l-.3.3-.1.6q0 .6.3.8l.5.1h.6v.2h-.1l.1-.1v-.1H24l-.5-.1q-.2-.2-.3-.8l.1-.5.5-.5.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24.8 19.4-.1.2h.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcca3d",
    d: "M25.2 19.5h-.3l-.1-.1-.1-.1h-.2l-.5-.5h.9l.1.2h.1v.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#af7029",
    d: "M25.2 19.5h-.4v.4h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcca3d",
    d: "M24.9 16.9v-.3l-.2-.2-.1-.1h-.3l-.1.1.4.5.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#af7029",
    d: "M24.7 17v.4-.2l.2-.2-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#816c2a",
    d: "M25 19.8v-.1h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6f5b24",
    d: "m25.2 19.6-.1.2-.2.1h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404118",
    d: "M25.2 19.8v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 16.6h-.5c-.2 0-.2-.6-.2-.6l-.1-.3.5-.5h.2v.2l-.1.2-.1.2v.1h.3l.1-.2-.2.2-.2.1q-.1.1.1.2h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab6d29",
    stroke: "#4d2a15",
    strokeWidth: 0.1,
    d: "M26.6 14.2s-.6 0-.6.4l.1.2q.3 0 .6.3l.3.4-.1.2.1.7.2.4.4-.2.2-.7-.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "m27.1 16.7.3-.3-.2-.2h.2v.2l.1-.3-.1-.2h-.2.2v-.3l-.1-.2H27h.3v-.2l-.2-.1H27l.1-.1h.2-.1l-.4-.2h-.2.1l-.2-.2h-.4.1v-.2h.4l.7.4.3.2.2.6v.9l-.5.3H27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2a567",
    d: "M26.5 14.4h-.4v.4l.1-.1h.3l-.1-.2h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "M27.2 16.7h-.1v.7l.7 1h.3v-.2h.2l.2.3h.2l.4.6v-.4l-.2-.2h.2l.2.1.1.1v.1l.1.2v.2l.2.2V19l-.2-.5v-.2.1l.2.2.1.2v.2l.1.1v.2h.1v-.9l.1.2v.4l.1.3.1.3.1.2v.1-1.5l.1.2v.3l.1.3v.3l.2.3v.2l.1-.2v-1.4l.1.1v.3l.1 1v.2l.3-2.4h.2l-.1-.2-.3-.4-.2-.4-.3-.6-.5-.6-.5-.4-.1-.1v-.2h-.4l-.3-.3-.4-.2h-.2l-.6-.2-.5-.1h-.5l-.2.2v.2l.2.2.6.3.1.2.1.1.1 1-.2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab6d29",
    d: "M27.8 18.2h.3l-.1-.5.2.2v.2l-.2.3h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "M31.3 20.4 31 20v-1.3l-.2-.2V18l-.3-.7v.1l.2.2h.4l.2.1v.3l.2.6-.1.6-.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "M31.3 19.3v-1.4l-.3-.2v.3l.1.1v.2l.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "M30.8 19.8v-1.1l-.3-.6-.2-.5-.1-.1H30v-.3l.2.1.3.3.2.7.2.4v1.4zm.2-2h.1l.1.2h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "M30.3 19.7v-1.1l-.4-.4-.1-.4-.2-.2v-.3l.3.2h.1l.2.8.1.2v.3l.2.6v.6zm-.3-.3V19l-.2-.4-.4-.5-.3-.4v-.2h.2l.2.2v.3l.1.2.2.2v.1l.1.3v.2l.2.3zm-.3 0V19l-.1-.3-.1-.2-.9-.7v-.3l.2.2h.1l.3.5.3.2v.2l.1.2.1.3zm-.4-.1L29 19v-.2l-.4-.4-.2-.3.4.4.2.2v.2l.1.2zm1.3-2s.2.3.3 0V17l-.4-.5-.5-.7h-.3.1l.5.8zM29 15.4q.2 0 .8 1 .6.6.4.8-.2 0-.3-.2l-.5-.7-.5-.4-.2-.4zm-.3 1 .8.9h.1v-.1l-.9-1zm0 0 .2.4.4.4v.2l-.4-.2.1.2-.2-.3-.1-.3-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "M27.5 17.5h.3v-.4s.4.5.4 0l-.1-.4.2.2.1-.2-.1-.4.1.1.3-.1-.2-.4.2-.1-.3-.3.2-.1h.4v-.2h-.2l-.3-.2h-.2l-.2-.1v.2l.1.4v1.1l-.1.1-.2.3-.1.1-.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab6d29",
    d: "m29 18.4-.1-.2-.3-.1.3.3zm.5 0-.2-.3-.2-.3H29v.3l.3.2zm.4 0-.2-.4-.2-.4v.3l.1.2zm.3 0v-.7l-.2-.2v.4l.1.3zm.3-1 .2.3.2.7-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2a567",
    d: "M28.4 18h.1l-.1-.3h.1v-.4l.1.3v.3q-.1.3-.2.2m.4-.3h.2l-.2-.2v-.1h.1l-.1-.4.2.3q.2.1.1.4c0 .2-.4 0-.4 0m1-.4v-.2h.2l-.2-.1h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2a567",
    d: "M29.1 17.5h.4l-.3-.3q0-.2.2 0 0 .2.2.2v-.2l.1.1.3.1v-.1.2h-.3v-.1.2h-.4zm1-.3.4.2-.1-.7s.3.7.2.8h-.2l-.2-.1zm1 1h.2l-.1.1m-.5-1.5h.1v-.2h-.1zm.4 1.2h.2q0 .2-.1 0zm-.7-2h.1v.2zm-.6-.5h.2v.1l.1.3-.3-.2zm-.2 0 .1-.2V15l-.3.2zm-.6-.3.4-.2h.1v.1l-.3.2zm0-.4-.2-.1.1.3v.2h.1zm-.5-.1q-.2-.3-.5-.3zl.1.3h.1v-.2zm-.5-.2q-.3-.3-.8-.3t-.4.2l.4.2h.4q.3 0 .3.2l-.2-.2-.2-.2h.2l.4.3v.2h.1v-.3zm-.8 2.3q.3 0 .5-.5l-.2-1q0-.1 0 0 .3.3.3.8t-.2.7l-.4.1m.4 1h.2q.2 0 .3-.3l-.2-.2V17h.2v.2h.1l.2-.2-.2-.3v-.1h.2v.2h.1l.2-.2-.2-.2h.2l.2-.2V16l.1.2-.1.2h-.2v.4l-.2.1v.4H28v.2l-.1.1-.2.1h-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2a567",
    d: "m28.6 16 .3-.2-.3-.4h.4v-.2h.1v.6l-.2.2zm.3 2.4v-.2h-.3zm.5 0-.2-.2-.2-.3v.3zm.4 0-.1-.3-.2-.4v.4zm.4-.2v-.4l-.2-.2v.2zm.6.2-.1-.4-.2-.4v.3l.2.4zm.6-.7-.3-.2-.5-.1.2.1.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "m29 17.8.1.3.4.4.2.5v.4l.1.2v-.2l-.1-.1-.2-.7-.6-.5v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "m29.6 19.1-.2-.4-.3-.3h-.2l-.3-.4.3.5.3.5v.2l.1.1-.1-.3-.2-.5.4.3zl.2.3zm-.5-1.7.3.2.3.6.2.3.1.6q.2.5.1.7l-.1-.4-.2-.5-.2-.3.2.3.2.4v-.4l-.2-.4-.2-.3-.2-.4v-.1h-.1zm.5 0 .2.1h.2l.1.6.3.4v.5l.1.7v.9-.6l-.3-.6-.1-.7-.2-.2.2.1.1.7.3.6-.1-.8-.1-.6-.2-.4-.2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "m30 17.2.3.2h.2l.1.7.3.3v2.4c-.2 0 0-.7-.1-.9l-.1-.2-.2-1-.1-.2.2.2v1l.2.3v-1.3l-.3-.8v-.3l-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "m30.6 17.3.3.3h.5l.2 1-.2.8v1.3l-.1.2-.1.2v-1.2l-.2-1.2-.1-.3.2.2V20v-.2l.2-.8-.2-.9v.2h.2-.1v2.1q.2-.1.2-1c0-.4.2-.4.1-.8l-.1-.7-.5-.2zm-3 .5h.2l.3-.3v-.1l.3-.2V17l.2-.3v-.2l.3-.2-.2-.3h.2l.1-.2-.2-.3h.2l.1-.2v-.1h.2l.3-.2-.2.2.2.2h.3-.2l.4.5h.2l.2.5h.1l.2.6-.5-.8-.4-.4.3.6.3.5s-.3-.7-.8-1l-.5-.5v.3l.6.7.6.8-.7-.8-.6-.5v.1h-.2l.4.5h.1l.2.1h-.2l.3.4h.3-.3l.2.3-.6-.6-.4-.3-.1.1h-.1l.4.5.3.4-.3-.3-.4-.3v.1l.4.5-.5-.5-.2.2.6.6-.5-.4.2.4-.3-.4-.1.1h-.2l.4.6-.4-.4.1.3-.2-.2-.2.1.1.2v.2-.2l-.2-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M31.4 17.7h.2l-.2-.2c-.1-.1-.4-1-.8-1.4q-.9-1.2-1-1.1s.6.3 1 1l.8 1.4.2.2v.1zm-4-.2.2-.2-.1-.1V17v.2h.2l.2-.3h-.1l-.1-.2.1.1h.2l.1-.3H28l-.1-.2.1.1h.2V16H28l-.1-.2.1.1h.2v-.3l-.1-.2h-.4.2l.2-.2-.1-.1v-.2h-.4.2v-.3l-.4-.3.6.5h.1v-.2l-.2-.2.2.2v.2l.4.1v-.2l-.1-.1v.1l.2.2.1.2h.2v-.4.5h.1-.1l-.7-.3.4.3.1.3-.1-.2-.4-.1v.2l.4.3-.1.1-.2-.1v.2l.2.3v.3l-.1-.1-.1-.1-.1.2.1.2v.2l-.2-.2-.1.3.1.1v.2l-.3-.2-.2.2.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "m29.6 15 .1-.2h-.2l-.4-.2s-.8-.6-2-.6q-.5 0-.6.2l.5-.2c.2 0 1.4.1 2 .6l.4.2h.3zm-2.1.2-.2-.3-.7-.4.6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2a567",
    d: "m27.5 16-.1-.1h-.2.2zm0-.4-.2-.1H27h.2zm-.1-.4-.2-.1H27h.2zm-.2-.2-.3-.1-.3-.1h.4zm-.5-.3h-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "m25.4 19.9.2.1.3.2-.2.2h-.4l-.1-.2zm0-.2-.2-.3v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "M25.3 20.1h.2m-.3 0q.2 0 .2-.3v-.1l-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3 20.1h.2m-.3 0q.2 0 .2-.3v-.1l-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "m25 20.1.2.1h.2l-.1-.2zm.3-.1H25h.1v-.1h.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "m25.2 20-.4.4v-.5h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "M24.8 19.9h.3l-.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202220",
    d: "m24 20.3.2.1.3-.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4b4139",
    d: "M24 20.3h.1l.1.1.3-.1-.3-.1zm0 0 .2-.1.3.1-.2.1a.1.1 0 0 1-.2 0v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202220",
    d: "M24.2 20.3h.4l-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4b4139",
    d: "M24.2 20.3h.5l-.3-.3zm0 0 .2-.3.2.2-.2.1zm0 0h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202220",
    d: "m24.4 20.1.2.2.1-.1-.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4b4139",
    d: "M24.4 20.1v.1l.2.1h.1v-.1l-.1-.3zm0 0 .2-.1.1.2zm0 0h.2zm-.3.1.1.1h.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "m24.8 19.9.1.2v.3l-.3-.3V20zm-.7 0h-.2v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "M24 20v.2h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "m24.1 20-.1.2v.1h.2zm0-.3-.1.1v.2h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "m24.2 19.8-.2.2.1.1.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "m24.4 20.1-.2.2-.1-.2.2-.1zm.1-.6h-.1l-.2.1v.3l.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "m24.3 20-.1-.2.2-.1v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "m24.6 20-.2.1h-.1v-.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "M24.4 19.8v.1l.2.1h.1l.1-.2v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202220",
    d: "M24.7 19.4h-.2l-.1.2v.2h.2v-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4b4139",
    d: "M24.7 19.4h-.2v.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "M27.4 21.4h.1l.2-.1v.1l-.1.2h-.1zm-.2 0h.2v.1l-.1.1h-.1zm1 0v-.1L28 21v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "M27.2 21.4h-.1l-.2.1v.3h.2l.6-.3h-.3v.1h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "M27.5 21.6h-.2v.2h.3v-.2zm.9-.1v-.1H28v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "M27.7 21.4h-.1l-.1.2h.4v-.2zm.8.2-.1-.1-.1.1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "M28.2 21.7h.1l.1.3h.2l.2-.2-.1-.2h-.2l-.1.1zh-.1v-.1H28v-.1l-.2.1v.1h-.2l-.1.2-.2-.1h-.1l-.1.2v.1h.4V22l.3-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2 21.7h.1l.1.3h.2l.2-.2-.1-.2h-.2l-.1.1zh-.1v-.1H28v-.1l-.2.1v.1h-.2l-.1.2-.2-.1h-.1l-.1.2v.1h.4V22l.3-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c83c",
    d: "M28 20.9v.6h-.3v-.3zm-.2.8h.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8 21.7h.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202220",
    d: "M26.8 22v-.2h.1v-.2l-.3.1q.1.3.2.2m.4.4v-.5q-.2 0-.2.2zm1.5-.2q.1.1.3-.2l-.2-.2-.1.2h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4b4139",
    d: "m27.2 22.4-.2-.3.1-.2-.1.2zm-.4-.5-.2-.2.3-.2-.3.2q.1.3.2.2m1.9.3h.1l.2-.1v-.3h-.2.1v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#904720",
    d: "m25.2 16 .2-.1h.3l.1.2-.3.2V16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M28 20.5V20l-1.2.4.5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2a567",
    d: "m25.8 19.7-.1-.1h-.2v.1l.3.1zm0 .2v.1l.1.1v.1h.1l-.4-.1v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2a567",
    d: "M26 20.2h.1v-.7l-.3-.4v.6l.1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab6d29",
    d: "M25.8 19.3v.2l.2.6-.1-.2zm.2.3v.3-.1.2l.1-.4m0 .8-.3-.1-.3-.2h.8v.2zm-.6-.1h-.1l.3.2h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2a567",
    d: "M25.4 20.2h.4v.2h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab6d29",
    d: "M26.2 20v.1zv-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "m25.8 19.7-.1-.2-.1-.3v-.1l.1.1v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2a567",
    d: "M25 20.3h.6v.2l-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "M26.2 19.6v.5H26h.1v-.3H26v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab6d29",
    d: "M25.4 20.3v-.1l.2.1h.3v.1l-.2.1v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "m25.8 19.7-.4-.5v-.4l.3.3v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab6d29",
    d: "M25.6 20.7v-.2l.6-.3v.2l-.5.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "M25.7 20.5v-.1l-.3-.1h.2zm.7 0-.1-.1v-.2h-.1l-.2.1h.2l-.3.1h.2l-.2.2h-.2v.1h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab6d29",
    d: "m26.4 20.6-.2-.4v-.5h.1l.1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "M26.4 20v.6l.1.1v-.2l.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M26.6 20.2v.6l-.2-.2.1.1zm-.2.4-.1-.1-.3.1h-.4q0 .1.4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab6d29",
    d: "m25.8 19.9.1.1.1.2V20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "M25.7 20.5h-.3l-.3-.2.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M25.7 20.5h-.3l-.3-.2.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab6d29",
    d: "M25.8 19.9h-.3v.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "m25.4 19.5.2.1.2.1v.2l-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "M25.7 19.6h-.1l-.1-.1v.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "m26.4 19.3 1.4-.8.6 1-1.2.3h-.6l-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "m28.3 19.7 1.7 1.5-.2.1-.4-.1-.9-.8-.3-.4zm2.2 1.2-1-.8-1.3-1v.5l1.5 1.3.5.3h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#803f1d",
    d: "M28.2 19.8s.5.6 1 .9q.5.6.8.5l-1.8-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "m29.5 21.3-.2.1h-.2l-1-1.2V20h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M30.5 20.9q0 .2-.4.2c-.3 0-1.9-1.5-1.9-1.5v.1s1.6 1.5 2 1.5l.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#803f1d",
    d: "m28 20 .8 1 .6.3v-.1l-.8-.8-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "m28.2 20 1.4 1.4.5-.2h-.5c-.2 0-1.4-1.2-1.4-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "m28.7 21.3-.5-.6v-.1l-.1-.3.9 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "m29.5 21.3-.3.1-.2-.1-.9-.9v-.1l1.1 1zm-.5 0h-.3l-.6-.6v-.2l.7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b07229",
    d: "m28.4 19.6.6.4.2.1.2.3h.3-.2l.3.3h.3-.2l.4.4-.5-.3v.1-.2l-.4-.2v.1-.2l-.3-.2v.1l-.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "M27.5 21v.3l-.3-.4v-.4l.2.3zm.7 0v-.7h-.3v.5l.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "M28 21.3V21l-.1-.4v-.2h-.2v.3l.1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M28 20.4v.2l.1.4.1.1V21l-.1-.4zl.1.4v-.6l.1-.1v-.5l-.6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M28 20.4v.9l-.1-.6-.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "M27.9 21.4V21l-.2-.4-.3-.2v-.1l-.1.3.3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M27 20.5v.3l.2.3.2.2.1-.2v.1l-.3-.5zm.6.5-.1-.3-.1-.1v-.2.1h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c3a1d",
    d: "m27.3 20.7.1.2.2.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M27.7 20.6v-.2h.1l-.2-.1zm0 0 .1.4v.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "M27.9 20.4v-.7l-.3-.5-.3-.1v.4l.4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8b441f",
    d: "M27 20.7q.2 0 0-.2l-.6-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8b441f",
    d: "M27.3 20.4v.3l-.8-1-.4-.2h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M27 20.7v-.2l-.1-.2-.5-.6-.2-.2v.2l.4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "M27.6 20.6v-.3q0-.4-.3-.8h-.1l-.2-.1-.1-.1v.4l.3.4zm.4-.5h.1v-.4l-.3-.8-.2-.1v.4l.3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M27.3 20.3 27 20l-.1-.3h-.2l-.2-.1.3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8b441f",
    d: "M27.9 20.4v-.7l-.3-.5.3.6v.3l-.2-.3-.1-.2.2.7-.5-.8s.3 1 .6 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "m28 18.4.3.4V20H28l-.1-.8-.1-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8b441f",
    d: "M27.6 20.6v-.2l-.2-.2V20h-.1l-.4-.4s.4 1 .7.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M27.4 20.2v-.3l-.1-.4h-.1l-.2-.1q0 .4.4.8m.3-.2-.2-.6-.2-.3v.3l.2.2zm.3-.5V19l-.1-.4.1.2v-.3.7zm.3 0v-.8l-.2-.3.1.5zm-.4.2-.1-.6-.1-.3h-.1v.4l.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#904720",
    d: "M28.1 20.2v-.6.2l-.2-.3zV20zm.1-.2v-.7l-.2-.6.2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#312317",
    d: "M27.4 20.5v.2l-.4-.2.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2a567",
    d: "M27.8 18.3h.2l.2-.2v-.2.2l-.2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "m27.7 17.9.2.4v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e2121",
    d: "m25.3 18.2 1 1.2 1-1.2-.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "M26.5 17.4v.5l.2.2.2.1v-.1l.1-.2h.2l.2-.3v-.2L27 17v.1h-.2l-.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c3818",
    d: "M27 18.3v-.7l-.2-.4.1.6zm.1-.5.2.2v-.5l-.1-.2v.2q.2.3.1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "m26.5 17.9.1-.1.1.2.1.2h.1v.1h-.3V18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2a567",
    d: "m26.8 19.7-.3-.1-.5-.6-.1-.2h.2l.3-.1v-.1l.4-.2.3-.2h.4l.1-.2.2.4v.5l-.2-.2v.5l-.3-.1v.4l-.5-.2q.1.1 0 .4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "M26.8 19.1v.5l-.2-.3-.2-.3zm.8-1s.2.6.1.7l-.3-.3-.3-.5H27v-.1h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "m26.5 19.4-.1-.2-.3-.2-.2-.2v-.2l.6.4zm.7 0-.5-.4-.3-.4v-.2zm0-.3-.2-.2v-.3zm.2 0-.3-.5-.2-.2h-.1l.1-.2h.1l.4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab6d29",
    d: "M26.5 19.6q-.6-.1-.9-.6l-.2-.4v-.2l.8 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "M26.5 19.6q-.1.1-.6-.4l-.5-.6v-.2h.1l.5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "m27 19.2-.2-.2-.3-.5v-.2h.2l.2.2.1.1.1.4-.2-.2zm-.3 0q0 .2 0 0l-.2-.2v.2l-.3-.3-.2-.3v-.4.1l.3.4h.1l.2.3zm-1-.6.4.6q0 .3.4.4zm1.7.3-.3-.3-.1-.4v-.3l.3.3.1.3h-.2zm.2-.3-.1-.2V18l-.2-.2v-.3h.1l.2.2v.8m-1.8.7-.4-.5v-.3l.4.7.4.3v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "m26.1 19.7-.5-.6-.3-.5v-.1zm.4-.1L26 19l-.2-.4h.1l.2.3zm0-.6-.3-.4-.2-.3.3.3h.1zm0-.9v.3q0 .3.3.4l-.1-.2-.1-.3.2.1.2.2-.1-.2zm.9.5-.2-.4-.1-.4v.2l-.1.3h-.1.1l.1-.1.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M27 17.8q0 .2.2 0v-.2h.2v-.2l.3.5.1.5-.2-.5-.2-.3v.5l.2.3-.2-.2v-.1l-.2-.1H27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M26.4 18.6q0 .3.4.5l-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "M27.5 18.7h-.1l.1.2h.1v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2a567",
    d: "M25.5 17.5h-.1l-.1.3v.4l.2.3.3.3.2-.3v-.3l.1.2.2.2.2-.3-.3-.8-.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab6d29",
    d: "m26.2 18.1.1.3v.2l.2-.3v-1l-.3.3zm-.6-.2.1.5.1.2.2-.4-.1-.4v-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#45392d",
    d: "m25.2 17.3-.2.6v.3l.1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab6d29",
    d: "m25.2 17.3-.2.6.1.4v.4h.2l.2-.2-.1-.2V18h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbad6c",
    d: "m26.4 18-.1-.1v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2a567",
    d: "m25.3 17.4-.2.6.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "M25.7 17.5v.1l-.2.2v.2-.1l.1-.1v.6-.3l.1.2V18l.2-.2v-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbad6c",
    d: "M26.4 18.2h-.1V18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "M25.4 18.2v.1l-.1.2V18h-.1v-.3l-.1.2v-.2l.2-.2v-.1h.1zm.8-.7v.2l-.1.1v.2-.2.2l.2.2V18h.1l-.1-.1v-.2l.1.1v-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e2121",
    d: "m27 17.2.2.6-.2-.3zh-.1v.4-.2l-.1-.1v.4-.1.2l-.1-.1v.3l.2.2-.2-.2v-1l.1-.4zm-.7-.1-.1.3H26l.2-.2zm-.9.3.1.2.4-.3v-.1l-.4.2m0-.3v.2h-.2.1zm1.7-.2.1.2.2.3-.2-.2v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbad6c",
    d: "M25.2 17.3h.2V17v.2l.1.1h.2l.2-.2v.2q0 .2.2 0l.2-.2.1-.2.1-.4h-.3v-.1l-.1.1H26l-.1.1-.1-.2-.2.2h-.2v.2l-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "M26.2 16.8v.3l-.2.3.3-.3v-.5zm.2-.2v.6l.1.2.2-.2.1-.3.1.2h.2v-.4l-.2-.3v-.1h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab6d29",
    d: "M26.8 16.3v.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "M27.1 16.9v.2l-.1-.3-.1-.3v-.2zm-.6.4q.2 0 .3-.6v-.4l-.2.5-.1.3.1-.1v.3m-.1-.7-.1.2-.3.1.2-.2v-.2l-.1.1H26l.1-.3.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e2121",
    d: "m27 16.1.1.8-.1-.3v-.2l-.2-.1v-.1zm-.4.8.1-.3v-.3l-.2-.2v.2l-.1.3.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "m25.1 17.2.1-.2.2-.3.3-.1v-.2l.2.2v.6-.3l-.1.1-.1.1v-.4l.1-.1h-.1l-.1.1-.1.3-.1.2V17l.1-.2-.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#874f20",
    d: "M27.1 16v.1h-.2V16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b27129",
    d: "M25.5 16.3v.1l-.2.3h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbad6c",
    d: "m26.5 16-.1.6-.3-.3s0 .4-.2.4l-.1-.3-.2.2q-.2.1-.2 0l.1-.3h.1l.1-.2h.3v-.2h.2v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b27129",
    d: "m26 15.6.2.3v.3-.1l.1-.1v.5l.2-.4q0-.2 0 0l.3.2v-.6l-.5-.3v.1c0 .1-.4 0-.4 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "M26.7 15.5v.7l-.2-.1v-.4l-.1-.2v-.2h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "m26.6 15.4.2.3.2.3h.1-.2l-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e2121",
    d: "m26.5 15.2.3.3.2.3.1.2-.2-.1-.2-.4-.2-.1.1.1.1.3v-.2l-.3-.2.1.2.1.3-.1-.2-.1-.2-.1-.2h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "M26 15.6h.3v.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b27129",
    d: "m26 15.9.1.3-.2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "M25.9 16h-.2v.2l-.2.3.2-.2.1-.2h.1v.3l.2-.3V16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbad6c",
    d: "M26.5 15v.3h-.3L26 15h-.2.4l.1.1h.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab6d29",
    d: "M26.5 15v.2h-.2L26 15h-.3.4l.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "M25.6 15h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbad6c",
    d: "M26.3 15.4v.2l-.2-.1-.3-.2h-.2V15h.3l.2.1zm-.3.1.2.4-.5-.3-.1.3-.4-.2.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab6d29",
    d: "m26 15.1.2.1.2.1h-.3l-.2-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "m25.6 15 .2.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab6d29",
    d: "M26.3 15.5H26l-.2-.2h-.3v-.1h.3l.2.1zm-.5.2v.3h-.1v-.1l-.2-.1.1-.1v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "m25.6 15.2.3.1.2.1.2.1H26l-.2-.2h-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab6d29",
    d: "M26.2 15.8h-.3l-.2-.2h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "m26.2 15.8-.4-.2h-.1l-.3-.2v.2h.2v.2-.1h.2l-.1-.1h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbad6c",
    d: "m25.7 15.6.2.3q-.1.3-.2.1l.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6c3f18",
    d: "M24.7 15v.2l-.3.3-.2.3.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbad6c",
    d: "M25.5 14.6v.5l-.3.5-.6.3h-.3v-.2l.2-.2.1-.2V15h.1v.4l.2-.1.1-.1.1-.1.1-.3v-.2.2l.1.2.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#904720",
    d: "M25.6 16v.1l-.1.2v-.1l-.2-.1v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab6d29",
    d: "M25.5 16q.2 0 .1-.1zl-.2-.1h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#904720",
    d: "M24.7 15.6h.4l.2-.2.2-.4v-.4s.3.3 0 .7q-.2.4-.3.3h.3v.2l.2.1h-.3l-.2.1h-.8l.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab6d29",
    d: "m25.3 15 .2-.2v-.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#904720",
    d: "M25.3 14.7v.5c-.1.2-.6.4-.6.4l.5-.4v-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e2121",
    d: "M24.9 15.6h.2l.2-.2-.2.1H25zm.3-.4v-.6zm.1 0h.2v-.3.2zm0 .8h.2zm-.3-.2.3-.1h.3l-.3.1zh.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.7 15.5v.3h-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f16e16",
    d: "M24.7 15.5v.3h-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab6d29",
    d: "m24.7 15.4.2-.3v-.3l.1.2v.2l.2-.6v.3q0 .4-.3.4l-.3.3-.2.3.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#904720",
    d: "M24.7 15.5V15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d2a15",
    d: "M25 15.2v-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab6d29",
    d: "M24.3 16v-.2l.1-.2.2-.2V15v.3q0 .3-.3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6c4119",
    d: "M25.5 16.3V16h-.3.2zm0 0v-.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bf802d",
    d: "m24.6 16.3.1.1h.3l.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9c83a",
    stroke: "#8f4620",
    strokeWidth: 0.1,
    d: "M25.3 16.2V16h-.5l-.3-.1h-.1l-.2-.1h-.1v.2q-.2 0-.3.3.2.6.5.4l-.2-.3.4-.2.3-.1h.3l-.4.2v.1s.7-.2.6-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcf3d8",
    d: "m24.1 16.7-.2-.3q0-.3.3-.3v-.2h.2l.1.1s-.4.2-.4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdeaaf",
    d: "M25.3 16.2 25 16h-.8v-.1l.5.1h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#513625",
    d: "M24.6 16.3h.2l.2-.1-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9c83a",
    d: "m24.2 16.9-.2-.1-.2-.3.1-.3.2-.1-.2.1v.4l.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8b5122",
    d: "M24.2 16H24zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9c83a",
    d: "M24.6 16.2h-.3.8l-.4.2h.3l.1-.1V16h-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f4620",
    d: "m24.1 16.6.2.2H24l-.3-.3v.2h.1l.2.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcca3d",
    d: "m24.8 16.5-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#816c2a",
    d: "M25.2 19.6H25l-.2-.1h.2zm0-.2h-.3.2m0-.3-.3.2h-.1.3zM25 19v.1l-.3.3.2-.2zm-.2 0v.3h-.1v.1l.1-.3zm-.2-.1v.4zm0 0-.1.3v.2-.5m-.2 0v.5-.4m-.1 0v.2l-.1.2V19m-.2 0v.3h.1v.1h-.1l.2-.1zm0 0-.1.2h-.1l-.1.1.2-.1zm-.2 0-.1.1zm0-.1h-.1v.1h-.1zm0 0h-.2zm0-.1h-.2zm-.1-.2-.1.1zm0-.1h-.1v.1zm.9-1.1V17h-.1zm0-.2.1-.1zm0-.1V17l.2-.1h-.2zm-.2-.1.3-.2zm0-.2.2-.2h-.1l-.2.2m-.2 0 .3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78732e",
    d: "m24.5 16.3.3.2.1.3q0 .3-.2.5l-.6.5-.2.3v.6l.3.2.4-.1.4.1.2.5-.1.5v-1l-.5-.1h-.4l-.3-.1-.1-.3.2-.4.5-.5.4-.6-.2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977c2e",
    d: "m25 20 .1-.1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(23 -40 70.9)scale(.31515 .31536)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15770"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-95.3 20.4 0)scale(.31251 .29007)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15770"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(50 -8.4 43.4)scale(.16277 .31957)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15770"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMx);
export default __webpack_public_path__ + "static/media/mx.a1fa6be4a74b71ee63b03319699cfd71.svg";
export { ForwardRef as ReactComponent };